import { Container, Row, Col, Card, ListGroup, Image } from 'react-bootstrap'; 
import TypeAnimation from 'react-type-animation';

export default function Awards() {
	return(
		<Container id="awards" className="mb-5">
	      	<TypeAnimation
	    	    cursor={false}
	    	    sequence={[ 
	    	       'Honors', 1000, 
	    	       'Appreciations', 1000, 
	    	       'Recognitions', 1000, 
	    	       'Certificates', 1000, 
	    	       'Awards', 1000]}
	    	    wrapper="p"
	    	    className="about-me-label mt-1 text-center"
	        />

	        <Row>
	        	<Col lg={4} xs={12} md={4} className="mb-2">
	        	    <Image fluid src="/images/awards/award1.jpg" />
	        	</Col>
		    	<Col lg={2} xs={12} md={2} className="mb-2">
		    		<Card>
		    			<Card.Header id="appearance-label">
		    				Most Likely To Be Famous Someday Award
		    			</Card.Header>
	    				<ListGroup className="list-group-flush">
	    				     <ListGroup.Item>
	    				     	<Card.Subtitle 
	    				     		className="mt-1 mb-1"
	    				     		id="appearance-sublabel"
								>
	    				     	   Date Awarded:
	    				     	</Card.Subtitle>
	    				     	<Card.Text id="appearance-data">
	    				     		February 20, 2020
	    				     	</Card.Text>
	    				     </ListGroup.Item>
	    				     <ListGroup.Item>
	    				     	<Card.Subtitle 
	    				     		className="mt-1 mb-1"
	    				     		id="appearance-sublabel"
								>
	    				     	   Given By:
	    				     	</Card.Subtitle>
	    				     	<Card.Text id="appearance-data">
	    				     		Zuitt Coding Bootcamp
	    				     	</Card.Text>
	    				     </ListGroup.Item>
	    				</ListGroup>	
		    		</Card>
		    	</Col>

	        	<Col lg={4} xs={12} md={4} className="mb-2">
	        	    <Image fluid src="/images/awards/award2.jpg" />
	        	</Col>
		    	<Col lg={2} xs={12} md={2} className="mb-2">
		    		<Card>
		    			<Card.Header id="appearance-label">
		    				AWS Udemy Certificate
		    			</Card.Header>
	    				<ListGroup className="list-group-flush">
	    				     <ListGroup.Item>
	    				     	<Card.Subtitle 
	    				     		className="mt-1 mb-1"
	    				     		id="appearance-sublabel"
								>
	    				     	   Date Awarded:
	    				     	</Card.Subtitle>
	    				     	<Card.Text id="appearance-data">
	    				     		Coming Soon
	    				     	</Card.Text>
	    				     </ListGroup.Item>
	    				     <ListGroup.Item>
	    				     	<Card.Subtitle 
	    				     		className="mt-1 mb-1"
	    				     		id="appearance-sublabel"
								>
	    				     	   Given By:
	    				     	</Card.Subtitle>
	    				     	<Card.Text id="appearance-data">
	    				     		Coming Soon
	    				     	</Card.Text>
	    				     </ListGroup.Item>
	    				</ListGroup>	
		    		</Card>
		    	</Col>
	        </Row>
           	<Row>
	           	<Col lg={4} xs={12} md={4} className="mb-2">
	           	    <Image fluid src="/images/awards/award3.png" />
	           	</Col>
	   	    	<Col lg={2} xs={12} md={2} className="mb-2">
	   	    		<Card>
	   	    			<Card.Header id="appearance-label">
	   	    				Information Security Awareness Training
	   	    			</Card.Header>
	       				<ListGroup className="list-group-flush">
	       				     <ListGroup.Item>
	       				     	<Card.Subtitle 
	       				     		className="mt-1 mb-1"
	       				     		id="appearance-sublabel"
	   							>
	       				     	   Date Awarded:
	       				     	</Card.Subtitle>
	       				     	<Card.Text id="appearance-data">
	       				     		December 8, 2022
	       				     	</Card.Text>
	       				     </ListGroup.Item>
	       				     <ListGroup.Item>
	       				     	<Card.Subtitle 
	       				     		className="mt-1 mb-1"
	       				     		id="appearance-sublabel"
	   							>
	       				     	   Given By:
	       				     	</Card.Subtitle>
	       				     	<Card.Text id="appearance-data">
	       				     		EMAPTA Academy
	       				     	</Card.Text>
	       				     </ListGroup.Item>
	       				</ListGroup>	
	   	    		</Card>
	   	    	</Col>

	           	<Col lg={4} xs={12} md={4} className="mb-2">
	           	    <Image fluid src="/images/awards/award4.png" />
	           	</Col>
	   	    	<Col lg={2} xs={12} md={2} className="mb-2">
	   	    		<Card>
	   	    			<Card.Header id="appearance-label">
	   	    				Empower Refresher Course
	   	    			</Card.Header>
	       				<ListGroup className="list-group-flush">
	       				     <ListGroup.Item>
	       				     	<Card.Subtitle 
	       				     		className="mt-1 mb-1"
	       				     		id="appearance-sublabel"
	   							>
	       				     	   Date Awarded:
	       				     	</Card.Subtitle>
	       				     	<Card.Text id="appearance-data">
	       				     		December 8, 2022
	       				     	</Card.Text>
	       				     </ListGroup.Item>
	       				     <ListGroup.Item>
	       				     	<Card.Subtitle 
	       				     		className="mt-1 mb-1"
	       				     		id="appearance-sublabel"
	   							>
	       				     	   Given By:
	       				     	</Card.Subtitle>
	       				     	<Card.Text id="appearance-data">
	       				     		EMAPTA Academy
	       				     	</Card.Text>
	       				     </ListGroup.Item>
	       				</ListGroup>	
	   	    		</Card>
	   	    	</Col>
           	</Row>
		</Container>
	);
};